import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-buy',
  templateUrl: './how-buy.component.html',
  styleUrls: ['./how-buy.component.scss']
})
export class HowBuyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
